import events from 'events-bus';
import { useEffect, useState } from 'react';

import Constants from '../Constants';

export const cartEvent = () => {
  const [cartBPs, setCartBPs] = useState<number | null>(null);
  const [sidCookie, setSidCookie] = useState<string | null>(null);

  useEffect(() => {
    function cartEventListener(eventName: string, data: any) {
      const cartBPsData = data.response.bonusPoints;
      const sidCookie = data.response.sid;
      setCartBPs(cartBPsData);
      setSidCookie(sidCookie);
    }
    events.on(Constants.EVENT.CART.GET_CART_SUCCESS, cartEventListener);

    return () => {
      events.off(cartEventListener);
    };
  }, []);

  return { cartBPs, sidCookie };
};
